import React from "react";

function LoaderFilling() {
  return (
    <div className="h-full absolute inset-0 w-full flex items-center justify-center z-[10]">
      <div className="cxl:translate-x-[180%]">
        <div className="loader-fill"></div>
      </div>
    </div>
  );
}

export default LoaderFilling;
